import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { productQueryKeys } from "./productQueryKeys";

export const useMutationDeleteProduct = ({ api }: { api: ApiType }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ productId }: { productId: number }) =>
      await api.productApi.delete(productId),
    onSuccess: async () =>
      await queryClient.invalidateQueries({ queryKey: productQueryKeys.all() }),
  });
};
